<header class="navbar navbar-expand-lg fixed-top bg-white">
  <div class="navbar-main navbar-dark bg-primary">
    <div class="nav-main dd-hover">

      <a href="javascript:;" class="navbar-brand" title="Mortem Abruzzo">
        <img src="assets/logo-abruzzo.png"/>
      </a>
      <div class="nav-splitter">
        <ul class="nav navbar-nav left">
          <!--li class="nav-item" [routerLinkActive]="['active']">
            <a routerLink="/dashboard" class="nav-item nav-link" style="cursor: pointer" [routerLinkActive]="['active']">Home</a>
          </li-->
          <li class="nav-item active">
            <a routerLink="/ricerca-schede" class="nav-item nav-link" style="cursor: pointer" [routerLinkActive]="['active']">SCHEDE</a>
          </li>
        </ul>
        <ul class="nav navbar-nav right">
          <li class="dropdown nav-item item-notify">
            <a href="javascript:" class="nav-link">
              <svg class="s-icon icon-sm">
                <use xlink:href="./assets/icons/sprite.svg"></use>
              </svg>
              <span class="badge badge-danger"></span>
            </a>
          </li>
          <li class="dropdown nav-item item-profile">
            <a href="javascript:" class="nav-link" data-toggle="dropdown" role="button" aria-expanded="false">
              <span class="s-icon icon-sm" style="font-size: 80%">{{getUtenteCharacters()}}</span>
            </a>
            <ul class="nav navbar-nav">
              <li class="disabled nav-item item-profile">
                <span class="nav-link"><span>UTENTE: </span> <span
                  style="font-weight: bolder; padding-left: 5px">{{utente?.userName}}</span></span>
              </li>
              <li class="disabled nav-item item-profile">
                <span class="nav-link"><span>RUOLO: </span> <span
                  style="font-weight: bolder; padding-left: 5px">{{utente?.nomeRuolo}}</span></span>
              </li>

              <!--li class="nav-item item-profile">
                <a routerLink="/documentazione">
                  <span class="nav-link">SUPPORTO: <svg class="s-icon icon-sm">
                  <use xlink:href="./assets/icons/sprite.svg#help"></use>
                </svg></span>
                </a>
              </li-->
              <li class="nav-item">
                <div class="nav-link bg-secondary justify-content-end"
                     style="cursor: pointer; color: white !important;padding-right: 20px" (click)="logOut()">
                  ESCI
                </div>
              </li>
              <li class="disabled nav-item item-label bg-gray-light" style="text-align: center" >
                <span class="text-secondary" style="font-size: 80%;text-align: center">Versioni: F.nd {{version}} - <span *ngIf="sVersion">B.nd {{sVersion}}</span><span class="alert-danger" *ngIf="!sVersion">Server non raggiungibile</span></span>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="navbar-mobile">
        <a class="mobile-login demon-unlogged demon-hide" href="">
          <!-- <div class="icon-round">
            <img src="assets/logo-abruzzo.png"/>
            <svg class="s-icon">
              <use xlink:href="assets/icons/sprite.svg#it-user"></use>
            </svg>
          </div> -->
        </a>
        <a class="mobile-hamburger" href="">
          <div></div>
          <div></div>
          <div></div>
        </a>
      </div>

    </div>
  </div>
  <div class="nav-mobile">
    <div class="mobile-inner"></div>
  </div>
</header>
